// extracted by mini-css-extract-plugin
export default {"image":"w2-z","loaded":"x2-z"};